import type { PageMetadata } from '@DigitaleDoerfer/digitale-doerfer-api';

const DEFAULT_PAGE_SIZE = 20;

export type PagedRequest = {
  page: number;
  count: number;
};

type PagedModel = {
  first?: boolean;
  last?: boolean;
  page?: PageMetadata;
};

export const getInitialPageParam = (
  pageSize: number = DEFAULT_PAGE_SIZE
): PagedRequest => ({
  page: 0,
  count: pageSize
});

export function getPreviousPageParam<
  TQueryFnData extends PagedModel,
  TPageParam extends PagedRequest
>(
  firstPage: TQueryFnData,
  _: TQueryFnData[],
  firstPageParam: TPageParam
): TPageParam | undefined | null {
  if (firstPage.first === true) {
    return;
  }
  const firstPageIndex = firstPage.page?.number ?? 0;
  const prevPageIndex = firstPageIndex - 1;
  if (prevPageIndex >= 0) {
    return {
      ...firstPageParam,
      page: prevPageIndex
    };
  }
}

export function getNextPageParam<
  TQueryFnData extends PagedModel,
  TPageParam extends PagedRequest
>(
  lastPage: TQueryFnData,
  _: TQueryFnData[],
  lastPageParam: TPageParam
): TPageParam | undefined | null {
  if (lastPage.last === true) {
    return;
  }
  const lastPageIndex = lastPage.page?.number ?? 0;
  const nextPageIndex = lastPageIndex + 1;
  const totalPageCount = lastPage.page?.totalPages ?? 0;
  if (nextPageIndex < totalPageCount) {
    return {
      ...lastPageParam,
      page: nextPageIndex
    };
  }
}
